import React from "react";

export const NotificationCardSkelton = () => {
  return (
    <li className="notification-item mt-2">
      <div>
        <div className="skeleton-text mb-2"></div>
        <p className="skeleton-div"></p>
        <div className="notification-item-footer">
          <span
            className="skeleton skeleton-text"
            style={{ width: "60px" }}
          ></span>
          <span
            className="skeleton skeleton-text"
            style={{ width: "60px" }}
          ></span>
        </div>
      </div>
    </li>
  );
};
